import React, { Component } from 'react';
import BillingJobDetails from './BillingJobDetails';
import { connect } from "react-redux";
import Button from "../../components/Common/Buttons/Button";
import { showModal } from "../../actions/modal.actions";
import moment from "moment";

export class BillingJob extends Component {

    state = {
        isJobExpanded: false,
    }

    handleExpandJob = () => {

        this.setState(() => ({
            isJobExpanded: !this.state.isJobExpanded,
        }));
    }

    displayBillingJobMonitorModal = () => {
        this.props.showModal('BILLING_JOB_MONITOR_MODAL', {
            billingJob: this.props.billingJob,
            canGenerateInvoices: this.props.canGenerateInvoices,
            canRejectBilling: this.props.canRejectBilling,
            canApproveBilling: this.props.canApproveBilling,
        });
    }

    render() {
        const {
            isJobExpanded,
        } = this.state;

        const {
            billingJob,
            currentUser,
            canMonitorBilling,
        } = this.props;

        const statusClass =
            billingJob.status === "TESTBILLING_SCHEDULED"      ? "bg-success-with-pulse"
            : billingJob.status === "TESTBILLING_STARTED"      ? "bg-success-with-pulse"
            : billingJob.status === "TESTBILLING_FINISHED"     ? "bg-success"
            : billingJob.status === "TESTBILLING_REJECTED"     ? "bg-secondary"
            : billingJob.status === "TESTBILLING_CANCELED"     ? "bg-secondary"
            : billingJob.status === "APPROVEBILLING_SCHEDULED" ? "bg-success-with-pulse"
            : billingJob.status === "APPROVEBILLING_STARTED"   ? "bg-success-with-pulse"
            : billingJob.status === "APPROVEBILLING_FINISHED"  ? "bg-success"
            : billingJob.status === "BILLING_FAILED"           ? "bg-danger"
            : "";

        const isRunning = ['TESTBILLING_SCHEDULED', 'TESTBILLING_STARTED', 'APPROVEBILLING_SCHEDULED', 'APPROVEBILLING_STARTED'].includes(billingJob.status);

        return (
            <div className="billing-job">

                <div className="billing-job-header">
                    <div className="row">
                        <div className="col-12 col-md-3 col-xxl-2">

                            <div className="billing-job-meta-pills">
                                <span className="billing-job-pill">
                                    <i className="fa fa-calendar-alt" />
                                    Invoice Date: {billingJob.invoiceDate ? moment(billingJob.invoiceDate).format("MM/DD/YYYY") : "N/A"}
                                </span>
                                <span className="billing-job-pill">
                                    <i className="fa fa-hashtag" />
                                    {billingJob.id || "N/A"}
                                </span>
                            </div>

                        </div>
                        <div className="col-12 col-md-9 col-xxl-10">

                            <div className="billing-job-caption">

                                <div className="billing-job-progress">
                                    <span className={"billing-job-progress-status " + statusClass}>
                                        {billingJob.status.toLowerCase().replace(/_/g, " ")}
                                    </span>
                                    {(billingJob.stage || billingJob.stageProgress) &&
                                        <span className="billing-job-progress-stage">
                                            {billingJob.stage && <span>{billingJob.stage}</span>}
                                            {billingJob.stageProgress && <span>{Math.round(billingJob.stageProgress * 100)}%</span>}
                                        </span>
                                    }
                                </div>

                                <div className="billing-job-pills">
                                    {billingJob.processedAccounts > 0 &&
                                        <span className="billing-job-pill">
                                            <i className="fa fa-users" />
                                            {billingJob.processedAccounts.toLocaleString()} {billingJob.processedAccounts === 1 ? "Account" : "Accounts"}
                                        </span>
                                    }
                                    {billingJob.totalInvoiceAmount &&
                                        <span className="billing-job-pill">
                                            <i className="fa fa-file-invoice-dollar" />
                                            ${Number(billingJob.totalInvoiceAmount).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                        </span>
                                    }
                                </div>

                                <div className="billing-job-caption-actions">
                                    {canMonitorBilling &&
                                        <span title="Billing Progress">
                                            <Button
                                                onClick={this.displayBillingJobMonitorModal}
                                                className="btn btn-xs btn-order-log-toggle btn-circle"
                                                type="button"
                                            >
                                                <i className={`fa fa-heartbeat${isRunning ? ' heartbeat-active' : ''}`} />
                                            </Button>
                                        </span>
                                    }

                                    <div className="billing-job-divider" />

                                    <div className="billing-job-controls">
                                        <button
                                            className="btn btn-circle"
                                            onClick={this.handleExpandJob}
                                        >
                                            <i className={"fas" + (isJobExpanded ? " fa-angle-double-up" : " fa-angle-double-down")} />
                                        </button>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                {isJobExpanded &&
                    <BillingJobDetails id={billingJob.id} />
                }

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = {
    showModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingJob);
